// extracted by mini-css-extract-plugin
export default {"rodape":"Rodape_rodape__ijuzC","social":"Rodape_social__M7sT4"};